import React from 'react';
import { Box, Typography, useMediaQuery } from '@mui/material';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.png';

const Footer = () => {
  const isMobile = useMediaQuery('(max-width:859px)');
  const isTablet = useMediaQuery('(min-width:860px) and (max-width:1279px)');

  const logoWidth = isMobile ? 128 : isTablet ? 160 : 233;
  const logoHeight = isMobile ? 32 : isTablet ? 40 : 56.65;

  const textStyles = {
    color: '#FFFFFF',
    fontFamily: 'Sora, sans-serif',
    fontWeight: 400,
    fontStyle: 'normal',
    fontSize: '16px',
    lineHeight: isMobile ? '142%' : '159%',
    letterSpacing: 0,
    textAlign: 'center',
    opacity: 0.6,
  };

  return (
    <Box
      sx={{
        backgroundColor: '#000000',
        textAlign: 'center',
        py: 8,
        borderTop: '1px solid rgba(255, 255, 255, 0.1)',
      }}
    >
      <Box display="flex" alignItems="center" justifyContent="center" gap={1} mb={3}>
        <img src={logo} alt="Logo" width={logoWidth} height={logoHeight} />
      </Box>

      {!isMobile ? (
        <>
          <Typography sx={textStyles}>©2026 AuraTap, an Authencity.io App by</Typography>
          <Typography sx={textStyles}>Artur Sychov and Phil Traut</Typography>
        </>
      ) : (
        <>
          <Typography sx={textStyles}>©2026 AuraTap, an</Typography>
          <Typography sx={textStyles}>Authencity.io App by</Typography>
          <Typography sx={textStyles}>Artur Sychov and Phil Traut</Typography>
        </>
      )}

      <Box display="flex" justifyContent="center" alignItems="center" gap={4} mt={3} flexWrap="wrap">
        <Typography
          component={Link}
          to="/privacy-policy"
          state={{ backgroundLocation: window.location.pathname === '/' ? { pathname: '/' } : undefined }}
          sx={{
            ...textStyles,
            opacity: 1,
            position: 'relative',
            textDecoration: 'none',
            cursor: 'pointer',
            '&::after': {
              content: '""',
              position: 'absolute',
              left: 0,
              bottom: -4,
              width: 0,
              height: '1px',
              backgroundColor: '#FFFFFF',
              transition: 'width 0.3s ease',
            },
            '&:hover::after': { width: '100%' },
          }}
        >
          Privacy Policy
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;
